import { render, staticRenderFns } from "./iiifannotation.vue?vue&type=template&id=81108800"
import script from "./iiifannotation.vue?vue&type=script&lang=js"
export * from "./iiifannotation.vue?vue&type=script&lang=js"
import style0 from "./iiifannotation.vue?vue&type=style&index=0&id=81108800&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports